module.exports = __webpack_public_path__ + "upload-file.svg?9086820628cf1a12bd463a70080e3b87";